import { render, staticRenderFns } from "./BannerMobile.vue?vue&type=template&id=45e3cead&scoped=true"
var script = {}
import style0 from "./BannerMobile.vue?vue&type=style&index=0&id=45e3cead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e3cead",
  null
  
)

export default component.exports